import { createFileRoute } from "@tanstack/react-router";
import { ChangelogAdminPage } from "@/components/changelog/admin-page";
import { requirePermission } from "@/lib/casl/route-guards";

export const Route = createFileRoute("/_authenticated/changelog/")({
  component: ChangelogAdminPage,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "manage", "settings");
  },
});
